(function() {
  // Run after DOM is ready
  function init() {
    // Get current currency from URL or page
    function getCurrentCurrency() {
      // Try to get from Shopify global variable
      if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
        return Shopify.currency.active;
      }
      
      // Try to get from URL
      const urlParams = new URLSearchParams(window.location.search);
      const currencyParam = urlParams.get('currency');
      if (currencyParam) {
        return currencyParam;
      }
      
      // Try to get from page elements
      const currencyElements = document.querySelectorAll('.currency-selector .selected-currency, [data-currency-active]');
      for (let el of currencyElements) {
        const currency = el.textContent.trim() || el.getAttribute('data-currency-active');
        if (currency && currency.length === 3) {
          return currency;
        }
      }
      
      return 'USD'; // Default fallback
    }
    
    // Store the current currency
    const currentCurrency = getCurrentCurrency();
    localStorage.setItem('shop_currency', currentCurrency);
    
    // Function to redirect with correct currency
    function redirectWithCurrency(currency) {
      if (!currency) return;
      
      // Don't redirect if we're already on the right currency
      if (window.location.href.includes(`currency=${currency}`)) return;
      
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('currency', currency);
      window.location.href = currentUrl.toString();
    }
    
    // Check if we need to redirect when on cart page
    if (window.location.pathname.includes('/cart')) {
      const storedCurrency = localStorage.getItem('shop_currency');
      if (storedCurrency && storedCurrency !== getCurrentCurrency()) {
        redirectWithCurrency(storedCurrency);
      }
    }
    
    // Add event listeners to currency selectors
    document.querySelectorAll('.currency-selector select, .currency-selector a, [data-currency]').forEach(function(el) {
      el.addEventListener('change', function() {
        const newCurrency = this.value;
        if (newCurrency) {
          localStorage.setItem('shop_currency', newCurrency);
        }
      });
      
      el.addEventListener('click', function(e) {
        const newCurrency = this.getAttribute('data-currency');
        if (newCurrency) {
          localStorage.setItem('shop_currency', newCurrency);
        }
      });
    });
    
    // Monitor for cart button clicks
    document.querySelectorAll('a[href="/cart"], a[href*="/cart?"], button[type="submit"][name="checkout"]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        const storedCurrency = localStorage.getItem('shop_currency');
        if (storedCurrency) {
          // If this is a checkout button, make sure the correct currency is set
          if (this.name === 'checkout') {
            const currentCurrency = getCurrentCurrency();
            if (storedCurrency !== currentCurrency) {
              e.preventDefault();
              redirectWithCurrency(storedCurrency);
            }
          }
          
          // If this is a cart link, modify it to include currency
          if (this.href && this.href.includes('/cart')) {
            e.preventDefault();
            let cartUrl = new URL(this.href);
            cartUrl.searchParams.set('currency', storedCurrency);
            window.location.href = cartUrl.toString();
          }
        }
      });
    });
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();